import { Box, Container, styled, ToggleButton, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";
import {
    MiscSavio,
    StyleguideSavioColors,
    StyleguideSavioFonts,
    themeSettings,
} from "../../../configuration/themeSettings";
import { FilterSearch } from "./Filter/FilterSearch";

export const Root = styled("div", { label: "searcpPartsPage" })(() => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
}));

export const Content = styled("div", { label: "searche-content" })(
    ({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
    })
);

export const Title = styled("div", { label: "searche-content" })(
    ({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "left",
        alignItems: "left",
        position: "relative",
    })
);

export const ButtonsContainer = styled(Box, {
    label: "search-buttonsContainer",
})(({ theme }) => ({
    textAlign: "end",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingRight: 8,
    ".MuiToggleButton-root": {
        border: 0,
        color: StyleguideSavioColors.mainBlue,
        marginRight: 10,
        borderRadius: 4,
        "&:hover": {
            color: StyleguideSavioColors.white,
            backgroundColor: MiscSavio.hoverBackgroundTable,
        },

        "&:last-child": {
            marginRight: 0,
        },

        svg: { fontSize: 25 },

        "&.Mui-selected": {
            backgroundColor: StyleguideSavioColors.mainBlue,
            color: "#fff",

            "&:hover":{
                backgroundColor: StyleguideSavioColors.blue,
            },
            "&:hover:not(.Mui-selected)":{
                backgroundColor: MiscSavio.hoverBackgroundTable,
            }
        }
    }
}));

export const SubContainer = styled(Box, { label: "searche-subContainer" })(
    ({ theme }) => ({
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        alignItems: "center",
        maxWidth: MiscSavio.maxWidth1500,
        boxSizing: "border-box",
    })
);

export const StyledToggleButton = styled(ToggleButton)({
    padding: "2px !important",
    height: "fit-content",
});

export const useSearchClasses = () => {
    const theme = useTheme();
    const classes = {
        title: {
            textAlign: "left",
            fontWeight: StyleguideSavioFonts.bold,
            fontSize: 20,
            display: "flex",
            alignItems: "center",
            color: StyleguideSavioColors.text.grayTitles,
        } as SxProps,

        numberSearchPage: {
            textAlign: "left",
            fontWeight: StyleguideSavioFonts.bold,
            fontSize: 12,
            display: "flex",
            alignItems: "center",
            color: StyleguideSavioColors.text.black,
        } as SxProps,

        searchResultHeaderTitleDesktop: {
            "& h4": { fontSize: "20px", paddingLeft: "10px" },
        } as SxProps,

        toggleButton: {
            padding: "2px",
            height: "fit-content",
            "&.Mui-selected, &.Mui-selected:hover": {
                backgroundColor: StyleguideSavioColors.darkBlue,
            },

            //background: "red"
        } as SxProps,

        filtersNotVisible: {
            height: "calc(100vh - 250px)",
            display: "flex",
            width: "100%",

            "> div": {
                height: "auto",
            },
        },

        filtersVisible: {
            height: "calc(100vh - 335px)",
        },
    };
    return classes;
};

export const SearchBoxResultDesktopContainer = styled(Box, {
    label: "search-BoxResultDesktopContainer",
})(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "center",
}));

export const SearchResultHeaderTitle = styled(Box, {
    label: "search-HeaderTitle",
})(({ theme }) => ({
    display: "flex",
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textTransform: "uppercase",
    borderBottom: "1px solid " + theme.palette.grey[100],

    "& h4": {
        paddingLeft: "10px",
        lineHeight: "30px",
    },
}));

export const SearchResultHeaderContainer = styled(Box, {
    label: "search-HeaderContainer",
})(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "center",
    borderBottom: "1px solid " + StyleguideSavioColors.lightGrey,
}));

export const SearchIconWrapper = styled("div", { label: "search-IconWrapper" })(
    ({ theme }) => ({
        display: "flex",
        marginRight: "20px",
        "svg":{color: StyleguideSavioColors.grayBreadcrumb,}
    })
);

export const SearchResultContentContainer = styled(Box, {
    label: "search-ContentContainer",
})(({ theme }) => ({
    zIndex: "unset",
    width: "100%",
    // height: "calc(100vh - 50px)",
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 160px)",
    left: "auto",
    "-webkit-overflow-scrolling": "touch",
}));

export const SearchResultContentHeader = styled("div", {
    label: "search-ContentHeader",
})(({ theme }) => ({
    width: "100%",
    overflow: "unset",
    height: "auto",
}));

export const LinearProgressWrapper = styled("div", {
    label: "search-LinearProgressWrapper",
})(({ theme }) => ({
    width: "95%",
    "& > * + *": {
        marginTop: theme.spacing(2),
    },
}));

export const FilterBoxWrapper = styled(Box, {
    label: "search-FilterBoxWrapper",
})(({ theme }) => ({
    width: "100%",
    "& >div": {
        backgroundColor: "#fff",
        width: "100%",
        maxWidth: MiscSavio.maxWidth1500,
        margin: "0 auto",
    },

    ".MuiAccordion-root": {
        marginTop: 0 + " !important",
    },
}));

export const PageContainer = styled(Container, {
    label: "search-PageContainer",
})(({ theme }) => ({
    paddingLeft: 0 + " !important",
    paddingRight: 0 + " !important",
    "table thead tr:hover th.MuiTableCell-root": {
        backgroundColor: StyleguideSavioColors.lightestGrey + " !important",
    },
}));
